function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(-3402 -1407)"
}, /*#__PURE__*/React.createElement("g", {
  id: "pause"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path 72"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pause0_fill",
  transform: "translate(3402 1407)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path 73"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pause1_fill",
  transform: "translate(3424 1416.34)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path 74"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pause1_fill",
  transform: "translate(3414.66 1416.34)"
}))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "pause0_fill",
  d: "M 20 1.77636e-15C 16.0444 7.77156e-16 12.1776 1.17298 8.8886 3.37061C 5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C 0.00866556 16.0009 -0.387401 20.0222 0.384303 23.9018C 1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C 8.65492 36.9392 12.2186 38.844 16.0982 39.6157C 19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C 31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C 38.827 27.8224 40 23.9556 40 20C 39.995 14.6972 37.8862 9.61306 34.1366 5.86342C 30.387 2.11378 25.3028 0.00503048 20 0L 20 1.77636e-15ZM 20 38.664C 16.3086 38.664 12.7001 37.5694 9.63085 35.5185C 6.56157 33.4677 4.16936 30.5528 2.75672 27.1424C 1.34409 23.732 0.974478 19.9793 1.69463 16.3588C 2.41479 12.7384 4.19236 9.41277 6.80257 6.80256C 9.41278 4.19235 12.7384 2.41478 16.3588 1.69462C 19.9793 0.974469 23.732 1.34408 27.1424 2.75671C 30.5528 4.16935 33.4677 6.56156 35.5186 9.63084C 37.5694 12.7001 38.664 16.3086 38.664 20C 38.6577 24.9481 36.6892 29.6916 33.1904 33.1904C 29.6916 36.6892 24.9481 38.6576 20 38.664Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "pause1_fill",
  d: "M 6.10352e-06 21.328L 5.336 21.328L 5.336 0L 6.10352e-06 0L 6.10352e-06 21.328ZM 1.336 1.328L 4.00001 1.328L 4.00001 19.992L 1.336 19.992L 1.336 1.328Z"
}));

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.80e54933.svg";
export { ForwardRef as ReactComponent };